var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 15H1C0.724 15 0.5 14.776 0.5 14.5V6.5C0.5 6.224 0.724 6 1 6H4C4.276 6 4.5 6.224 4.5 6.5V14.5C4.5 14.776 4.276 15 4 15Z",
    fill: "#9F73E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 15H5.5C5.224 15 5 14.776 5 14.5V6.5C5 6.429 5.015 6.3595 5.044 6.2945L7.065 1.804C7.341 1.295 7.815 1 8.3185 1C8.5705 1 8.8155 1.0745 9.027 1.2155C9.582 1.585 10 2.4085 10 3.1315V5.5C10 5.7755 10.224 6 10.5 6H14C14.827 6 15.5 6.673 15.5 7.5L14.998 13.5415C15 14.327 14.327 15 13.5 15Z",
    fill: "#9F73E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1596_19436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 14H6.5C6.224 14 6 13.776 6 13.5V5.5C6 5.429 6.015 5.3595 6.044 5.2945L8.065 0.804C8.341 0.295 8.815 0 9.3185 0C9.5705 0 9.8155 0.0745 10.027 0.2155C10.582 0.585 11 1.4085 11 2.1315V4.5C11 4.7755 11.224 5 11.5 5H15C15.827 5 16.5 5.673 16.5 6.5L15.998 12.5415C16 13.327 15.327 14 14.5 14Z",
    fill: "white",
    fillOpacity: 0.17
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1596_19436",
    x: 4.1,
    y: -1.9,
    width: 14.3,
    height: 17.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1596_19436"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1596_19436",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVotes);
export default __webpack_public_path__ + "static/media/votes.829775000a444c0bd6a2804590bc1393.svg";
export { ForwardRef as ReactComponent };